import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const dest = window.location.pathname || "/";
    (async () => {
      try {
        if (!sessionId) throw new Error("no session");
        await processGoogleSession(sessionId);
        toast.success("Signed in with Google.");
      } catch {
        toast.error("Google sign-in failed. Please try again.");
      }
      navigate(dest, { replace: true });
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen grid place-items-center bg-ink">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-signal mx-auto mb-4" />
        <div className="font-mono text-xs uppercase tracking-widest text-slate-400">Completing sign-in…</div>
      </div>
    </div>
  );
}
